import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
} from 'react-admin';
import { S3ImageInput } from './aws/S3ImageInput';

export default (props) => (
  <Create {...props}>
    <SimpleForm
      redirect="show"
      initialValues={{
        order: 0,
      }}
    >
      <TextInput source="eventId" disabled validate={[required()]} />
      <TextInput source="name" />
      <TextInput source="link" type="url" />
      <S3ImageInput
        source="image"
        accept="image/*"
        multiple={false}
        keyPrefix="brand-image/"
      />
      <NumberInput source="order" />
    </SimpleForm>
  </Create>
);
